export { ClinicalTrialsModal } from './clinical-trials-modal';
